import { Component, EventEmitter, Output } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-bulkexcelupload',
  templateUrl: './bulkexcelupload.component.html',
  styleUrls: ['./bulkexcelupload.component.css']
})
export class BulkexceluploadComponent {
  selectedFiles: File[] = [];
  fileArray: any[] = [];
  errorList: any[] = [];
  keys: string[] = [];
  master: String = "";
  zipFiles: File[] = [];
  @Output() fileEmit = new EventEmitter<any>();
  constructor(public ref: DynamicDialogRef,
    private utilityservice: Utilityservice,
    public config: DynamicDialogConfig,
    private spinner:NgxSpinnerService

  ) {
    this.fileArray = [];
    this.parentdata = this.config.data;
    this.master = this.parentdata.master;
  }

  addFileAtIndex(file: File, index: number) {
    // Check if the index is valid
    if (index >= 0 && index <= this.selectedFiles.length) {
      // Use splice to add the file at the specified index
      this.selectedFiles.splice(index, 0, file);
    }
  }
  // onFileSelected(event: any) {
  //   this.fileArray = [];
  //   this.selectedFiles = [];
  //   for (let i = 0; i < event.target.files.length; i++) {
  //     const fileList = event.target.files[i];
  //     const file: File = fileList;
  //     this.selectedFiles.push(file);
  //     const filedata = {
  //       activeflag: "Y",
  //       createdby: "Mohd Sameer",
  //       createdon: "29-Nov-2023 12:19:34 PM",
  //       size: file.size,
  //       id: 238145,
  //       originalfilename: file.name,
  //       productid: 8,
  //       programid: "audit/ia_dashboard.jsp",
  //       searchtag: "",
  //     }
  //     this.fileEmit.emit(this.selectedFiles)
  //     this.fileArray.push(filedata)

  //   }
  // }
  bytesToMB(bytes) {
    return (bytes / (1024 * 1024)).toFixed(2);
  }
  removeFileInput(index: number) {
    this.selectedFiles.splice(index, 1);
    this.fileArray.splice(index, 1);
  }


  get selectedFileNames(): string {
    return this.selectedFiles.length > 0 ? this.selectedFiles.map(file => file.name).join(', ') : 'No file chosen';
  }
selectedFileName=''
 onFileSelectedafter(event: any) {
    this.selectedFiles=[];   
    
    for (let i = 0; i < event.target.files.length; i++) {
      const fileList = event.target.files[i];
      const file: File = fileList;
      
          if (file) {
    this.selectedFileName = file.name;
  } else {
    this.selectedFileName = '';
  }
      this.selectedFiles.push(file);
      this.fileEmit.emit(this.selectedFiles);
      event.target.value = '';


    }
  }
  onFileSelected(event: any) {
    this.fileArray = [];
    this.selectedFiles = [];
    this.errorList = [];
    this.keys = [];
    this.fileEmit.emit([]);

    const allowedExtensions = ['xls', 'xlsx'];

    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      this.selectedFileName=file.name;

      if (!allowedExtensions.includes(fileExtension || '')) {
        Swal.fire({
          icon: 'error',
          title: 'Uploaded file format is invalid. Allowed extensions are .xls, .xlsx',
        });
        this.selectedFileName = '';
        return;
      }
      
          if (file) {
    this.selectedFileName = file.name;
  } else {
    this.selectedFileName = '';
  }
      this.selectedFiles.push(file);
      const filedata = {
        size: file.size,
        originalfilename: file.name,
      };

      this.fileEmit.emit(this.selectedFiles);
      event.target.value = '';
      this.fileArray.push(filedata);
    }
    // this.selectedFileName = '';
  }

  parentdata: any;
  fileuploadsave() {
    this.errorList = [];
    // working here for new
    const allowedExtensions = ['.xlsx', '.xls'];
    const validExcelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];

    for (let file of this.selectedFiles) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      if (!allowedExtensions.includes(fileExtension) || !validExcelTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: `Only .xlsx and .xls files are allowed. "${file.name}" is not valid.`,
        });
        return; // Stop the upload
      }
    }

    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No files selected',
        text: 'Please select file before process upload.',
      });
      return;
    }
    const formData = new FormData();
    for (let i = 0; i < this.selectedFiles.length; i++) {
      formData.append("file", this.selectedFiles[i]);
    }
    this.spinner.show();
    this.utilityservice.bulkUploadExcel(formData, this.parentdata.uploadapi).subscribe(res => {
      this.spinner.hide();
      const counter = res[0].counter || 0;
      const totalcount = res[0].totalCount || 0;
      const count = res[0].count || totalcount; // define count properly
      if (counter === 0) {
        this.errorList = res;
        this.keys = Object.keys(this.errorList[0]);
      } else {
        // ✅ No errors — show success with counter
        this.errorList = [];
        Swal.fire({
          icon: 'success',
          title: this.parentdata.sucessmessage,
          text: `(Total Count: ${totalcount} out of ${count} records uploaded)`
        }).then(() => {

          location.reload();
        });
      }
    },
      error => {
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Something went wrong',
        //     text: ''
        //   });
        // }         
        // if (
        //   error instanceof ProgressEvent ||
        //   error?.error instanceof ProgressEvent
        // ) {
        //   Swal.fire({
        //   icon: 'warning',
        //   title: 'File changed during upload',
        //   text: 'The selected file was modified. Please reselect the file and try again.'
        // }).then(() => { 
        //   const fileInput: HTMLInputElement = document.getElementById('file') as HTMLInputElement;
        //   if (fileInput) {
        //     fileInput.value = '';  
        //   }
        // });
        //   return;
        // }

        this.spinner.hide();
        Swal.fire(error.error.message,'','error');
        this.ref.close();
      }
    );
  }


  downloaderrorsheet() {
    //this.spinner.show();
    this.utilityservice.downloadExcelData('common/generic/errorsheet', 'post', this.errorList).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = "error_sheet";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      // this.spinner.hide();
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      //this.spinner.hide();
      Swal.fire(error.error.message, '', 'error');

    });

  }

  closemodel() {
    this.ref.close();
  }


}
